import { useContext, useEffect, useState } from 'react'
import { ReportingContext } from '../../../../contexts/reporting-context'
import DataCard from '../../../atoms/DataCard/datacard'
import useTotalWorkingDays from '../../../../hooks/useTotalWorkingDays'
import dayjs from 'dayjs'

export const TotalBooking = () => {
  const { reportSeatBookingsByTeam, reportBusinessUnit, reportDateRange, firstBookedSeat } =
    useContext(ReportingContext)
  const numberOfBookings = reportSeatBookingsByTeam.reduce(
    (total, current) => total + current.seats.length,
    0
  )
  const start =
    reportDateRange?.id !== 'start-to-date'
      ? reportDateRange?.startDate
      : dayjs(firstBookedSeat?.dateBooked)
  const totalworkingDays = useTotalWorkingDays(start, reportDateRange?.endDate)

  const [totalNumberOfBookings, setTotalNumberOfBookings] = useState<number>()

  useEffect(() => {
    if (reportBusinessUnit !== undefined) {
      setTotalNumberOfBookings(totalworkingDays * reportBusinessUnit.deskCapacity)
    }
  }, [totalworkingDays, reportBusinessUnit])

  const getTotalNumberBookingsPercentage = () => {
    return (
      numberOfBookings &&
      totalNumberOfBookings &&
      Math.round((numberOfBookings * 100) / totalNumberOfBookings)
    )
  }

  return (
    <DataCard
      id="total-bookings-card"
      title="Total Number of Bookings"
      content={{
        mainValue: numberOfBookings?.toString() || '0',
        quantifier: 'of',
        quantity: totalNumberOfBookings?.toString()
      }}
      footer={getTotalNumberBookingsPercentage() + '% of desks booked'}
    />
  )
}
